import { useState } from 'react';
import { Link } from 'react-router-dom'
import Styles from "../styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from '../authMedia';
import Headline5 from '../../../components/headings/Headline5';
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { ResetPasswordForm } from './resetform';
import workIcon from '../../../assets/images/work-anywhere.svg';
import globalIcon from '../../../assets/images/earn-globaly.svg';
import edgeIcon from '../../../assets/images/work-with-edge.svg';
import NotificationAlert from '../../../components/notification';
import mixpanelData, { userProfile } from '../../../utils/mixpanel';
import { getAPI } from '../../../api/apis';
import { REACT_APP_CANDIDATE_FREELANCER } from '../../../utils/common';


Auth.configure({
  userPoolId: "ap-south-1_xW3Zsub3t",
  userPoolWebClientId: "2jn6qgntppsud848ri333cud5s",  // app client id
  //identityPoolId: "42efbd0d-8bcb-46a2-b028-0a8affe3bb63",
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "authmyworkplace.ellow.io",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://myworkplace.ellow.io/login?provider=google",
    redirectSignOut: "https://myworkplace.ellow.io/login",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
})

function ResetPassword() {

  let navigate = useNavigate();

  let query: any = window.location.href
  let urlParams:any = new URL(query);
  let userName:any = urlParams.searchParams.get("username")
  let code:any = urlParams.searchParams.get('confirmationCode')
  let email = localStorage.getItem('Email')

  const[password, setPassword] = useState<any>()
  const [error, setError] = useState<string>('')
  const [notification,setNotification] = useState<boolean>(false)
  const [disable, setDisable] = useState<boolean>(false)

  const submitValues = (data: any) => {
    setDisable(true)
      Auth.forgotPasswordSubmit(userName, code, data.Newpassword)
      .then(confirmationResult => {
       mixpanelData('Test-Reset Password', {
         'source': "freelancer login with his account",
         'success':  true,
         'distinct_id': userName,
         'Email': email
       })
             
       setPassword(data.Newpassword)
       setNotification(true)
       setTimeout(() => {
         setNotification(false)
         signIn(userName, data.Newpassword);
          //  Auth.signIn(userName, data.Newpassword)
          //  .then(async (result: any) => {
          //    localStorage.setItem('loginId',result.username)
          //    navigate(`/basic-details`, {
          //      state: {
          //        loginId: result.username
          //      }
          //    });
          //  })
          //  .catch(err => {
          //    setError(err.message)
          //  });
 
       }, 4000);
    })
    .catch(err => {
    setError(err.message)
    mixpanelData('Test-Reset Password Failed', {
     'source': "freelancer login with his account",
     'success':  false,
     'distinct_id': userName,
     'Email': email
 
   })
   });
  }

  const signIn = (userName: any, password: any) => {
    Auth.signIn(userName, password)
    .then(async (result: any) => {
      localStorage.setItem('loginId',result.username)
      mixpanelData('Test-Login', {
        'source': "freelancer login with his account",
        'success':  true,
        'distinct_id': userName,
        'Email': email

      })
      getAPI(REACT_APP_CANDIDATE_FREELANCER + `/profile-completion-status?candidateId=${result.username}`).then((response) => { 
        if(response && response.status === 1){
          setDisable(false)
          userProfile({
            '$email': userName,
            '$name': response.data[0].profilemetadata.firstName + ' ' + response.data[0].profilemetadata.lastName
          }, result.username)
        localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profilemetadata))
        localStorage.setItem("candidate_status", response.data[0].status)
        localStorage.setItem('candidateid',response.data[0].candidateid)
        if(response.data[0].status === 1 )
        {            
          navigate(`/basic-details`, {
            state: {
              loginId: result.username
            }
          }) 
        }
        if(response.data[0].status !== 1 && response.data[0].emailverificationstatus === false){
          navigate(`/verification`, {
            state: {
              email: userName
            }
          })
        }
        if(response.data[0].status !== 1 && response.data[0].status !== 6  &&  response.data[0].status !== 7 && response.data[0].emailverificationstatus === true) {
          navigate(`/dashboard`, {
            state: {
              loginId: result.username
            }
          })
        }
        // if(redirect ==='contractsignin'){ 
        //   if(loginId === result.username){
        //     navigate(`/contractsignin`, {
        //       state: {
        //         loginId: loginId , candidateJobId: candidateJobId
        //       }
        //     }) 
        //   }
        // }
        if (response.data[0].status !== 6 || response.data[0].status !== 7) {
        setError('Sorry we are unable to process this request now, Please contact our team at team@ellow.io')
        }
        }       
       
    })
    })
    .catch(err => {
      mixpanelData('Test-Reset Password Failed', {
        'source': "freelancer login with his account",
        'success':  false,
        'distinct_id': userName,
        'Email': email

      })
      setError(err.message)
      setDisable(false)
    });
  }
  const onClose = () =>{
    signIn(userName, password)
  }

  return (
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <div className={Styles.alignCenter}>
          <aside className={Styles.loginSignupWapper}>
            
            <Headline5>Reset Your Password ?</Headline5>

            {notification&& <NotificationAlert closable={true} onClose={onClose}>Password updated successfully</NotificationAlert>}

            <div className={Styles.loginWith}>

                  <ResetPasswordForm  ClickHandler={submitValues} disable={disable}/>

              {error ?

                <div><p className="error-message">{error}</p></div>
                :
                <div></div>

              }
                
              <div className={Styles.alreadyRegistered}>Don’t have an Ellow account? <Link to="/signup">Sign up</Link></div> 
            </div>
            
          </aside>
          
          <div className={Styles.signupWith}>
            <div className={Styles.signUpFeatures}>
              <figure><img src={workIcon} alt="Work Anywhere" width="98" height="65" /></figure>
              <figcaption>Work<br />Anywhere</figcaption>
            </div>
            <div className={Styles.signUpFeatures}>
              <figure><img src={globalIcon} alt="Earn Global Pay" width="65" height="54" /></figure>
              <figcaption>Earn<br />Global Pay</figcaption>
            </div>
            <div className={Styles.signUpFeatures}>
              <figure><img src={edgeIcon} alt="Work with cutting edge companies" width="36" height="46" /></figure>
              <figcaption>Work with cutting edge companies</figcaption>
            </div>
          </div>
          </div>
          {/* <div className={Styles.privacyPolicy}>
            By creating an account, I agree to receive Arc communications via email,
            and agree with the ellow <Link to="/">Terms of Service</Link>, <Link to="/">Privacy Policy</Link>, and <Link to="/">Cookie Policy</Link>.
            I understand that I can unsubscribe at any time.
          </div> */}
        </div>
        <AuthMedia/>
      </div>
    </section>
  );
}


export default ResetPassword;
